import { UpdatableModel } from './updatable-model';

export class Preferences extends UpdatableModel<Preferences> {
  pageSize = 25;
  reportPageSize = 10;
  impersonationPrompt = true;
  name: string;
  title: string;
}
